import axios from "axios";
import React, { useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function UploadPhotos() {
  const [profilePics, setProfilePics] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const fileInputRef = useRef(null);
  const userid = localStorage.getItem("userId");
  const TOKEN = localStorage.getItem("adminToken");

  const handleFileUpload = (event) => {
    const files = Array.from(event.target.files);
    console.log(
      "Selected files:",
      files.map((f) => `${f.name} (${(f.size / 1024 / 1024).toFixed(2)} MB)`)
    );
    setProfilePics(files);
  };

  const uploadSingleFile = async (file, userId, token) => {
    const formData = new FormData();
    formData.append("profile_pic", file);
    formData.append("user_id", userId);

    console.log(`Starting upload for ${file.name} at ${new Date().toISOString()}`);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/profilepic/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          timeout: 60000, // 60-second timeout
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            console.log(`${file.name} progress: ${percentCompleted}%`);
            setUploadProgress((prev) => Math.max(prev, percentCompleted));
          },
        }
      );
      console.log(`Completed upload for ${file.name} at ${new Date().toISOString()}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!profilePics.length) {
      toast.error("Please select at least one photo to upload.");
      return;
    }

    if (!TOKEN) {
      toast.error("Authentication token missing. Please log in.");
      return;
    }

    setIsLoading(true);
    setUploadProgress(0);

    try {
      // Upload files one at a time to avoid server overload
      for (const file of profilePics) {
        await uploadSingleFile(file, userid, TOKEN);
        // toast.success(`Uploaded ${file.name} successfully!`);
      }

      toast.success("Photos uploaded successfully!");
      setProfilePics([]);
      setUploadProgress(0);
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        toast.error("Upload timed out. Please check your connection.");
      } else {
        toast.error(
          error.response?.data?.message ||
          `Failed to upload ${error.config?.data?.get("profile_pic")?.name || "photo"}. Please try again.`
        );
      }
      console.error("Upload error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <section className="page-info-sec">
        <div
          className="bg-fixed"
          style={{ backgroundImage: "url('/img/inner_banner.png')" }}
        ></div>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col">
              <div className="page-info-block">
                <h1>Upload Photos</h1>
                <p>Upload your photos here</p>
                <p className="page_nav">
                  <a href="/">Home</a>
                  <span className="mx-2">/</span>
                  <a href="#" className="currentPage">
                    Upload Photos
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="video-chat-form-sec secpd70">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mx-auto">
              <form onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="mb-3">
                  <label htmlFor="profile_pic" className="form-label mb-2">
                    Upload Photos:
                  </label>
                  <input
                    type="file"
                    name="profile_pic"
                    id="profile_pic"
                    className="form-control"
                    multiple
                    onChange={handleFileUpload}
                    ref={fileInputRef}
                    disabled={isLoading}
                    accept="image/*"
                  />
                </div>
                {uploadProgress > 0 && (
                  <div className="progress mb-3">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${uploadProgress}%` }}
                      aria-valuenow={uploadProgress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    >
                      {uploadProgress}%
                    </div>
                  </div>
                )}
                <button
                  type="submit"
                  className="btn btn-primary my-3"
                  disabled={isLoading}
                >
                  {isLoading ? "Uploading..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default UploadPhotos;